module.exports = __webpack_public_path__ + "static/media/facebook.947c2ca8.svg";